import clsx from "clsx";

import { AgentEnvironment } from "../redux/reducers/agentEnvironmentSlice";
import { DropdownField } from "./base/DropdownField";
import { Text, View } from "./base";
import { AgentEnvironmentPill } from "./AgentEnvironmentPill";

type AgentEnvironmentDropdownFieldProps = {
  agentEnvironments: AgentEnvironment[];
  value: string;
  onChange: (environmentId: string) => void;
  label?: string;
  className?: string;
  showAllEnvironments?: boolean;
  readOnly?: boolean;
};

export const AgentEnvironmentDropdownField = ({
  label,
  agentEnvironments,
  value,
  onChange,
  className,
  showAllEnvironments = false,
  readOnly = false,
}: AgentEnvironmentDropdownFieldProps) => {
  const options = agentEnvironments?.map((agentEnvironment) => {
    return {
      value: agentEnvironment.id,
      label: <AgentEnvironmentPill environment={agentEnvironment.name} />,
    };
  });

  if (showAllEnvironments) {
    options.unshift({
      value: "all",
      label: (
        <View className="flex items-center gap-2">
          <Text className="text-sm font-medium text-gray-700 dark:text-gray-300">All Environments</Text>
        </View>
      ),
    });
  }

  return (
    <DropdownField
      label={label}
      options={options}
      value={value}
      onChange={onChange}
      readOnly={readOnly}
      className={clsx("w-full", className)}
    />
  );
};
